import { formatUnits } from 'viem'

export function ellipseAddress(address: string | null | undefined, width = 6): string {
  if (!address) {
    return ''
  }

  if (width === -1) {
    return address
  }

  return `${address.slice(0, width)}...${address.slice(-width)}`
}

export const formatBalance = (
  value: bigint | undefined,
  decimals: number = 18,
  displayDecimals: number = 4,
): string => {
  if (!value) return '0'

  try {
    const formattedValue = formatUnits(value, decimals)

    const [whole, fraction = ''] = formattedValue.split('.')
    const truncatedFraction = fraction.slice(0, displayDecimals)

    const cleanFraction = truncatedFraction.replace(/0+$/, '')

    return cleanFraction ? `${whole}.${cleanFraction}` : whole
  } catch (error) {
    console.error('Error formatting balance:', error)
    return '0'
  }
}
